import React, { Suspense, lazy } from 'react';

import ClientSideComponent from 'Jsx/Shared/ClientSideComponent';

const CookiesBanner = lazy(
  () => import(/* webpackChunkName: "cb-cb-lzcb" */ './CookiesBanner'),
);

const LazyCookiesBanner = () => (
  <ClientSideComponent>
    <Suspense fallback={null}>
      <CookiesBanner />
    </Suspense>
  </ClientSideComponent>
);

export default LazyCookiesBanner;
